const FOCUSABLE_SELECTOR = [
  'a[href]',
  'button:not([disabled])',
  'input:not([disabled])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  'summary',
  '[tabindex]:not([tabindex="-1"])'
].join(',')

function visibleFocusable(element) {
  return element.offsetParent !== null || element === document.activeElement
}

function focusableChildren(element) {
  return Array.from(element.querySelectorAll(FOCUSABLE_SELECTOR)).filter(visibleFocusable)
}

function installTrap(element, binding) {
  const options = binding.value || {}
  const onEscape = options.onEscape

  const handler = (event) => {
    if (event.key === 'Escape' && typeof onEscape === 'function') {
      event.preventDefault()
      onEscape(event)
      return
    }
    if (event.key !== 'Tab') return

    const focusable = focusableChildren(element)
    if (focusable.length === 0) {
      event.preventDefault()
      element.focus()
      return
    }

    const first = focusable[0]
    const last = focusable[focusable.length - 1]
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault()
      last.focus()
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault()
      first.focus()
    }
  }

  element.__scribe11FocusTrap = handler
  element.addEventListener('keydown', handler)
}

function removeTrap(element) {
  if (!element.__scribe11FocusTrap) return
  element.removeEventListener('keydown', element.__scribe11FocusTrap)
  delete element.__scribe11FocusTrap
}

export const focusTrap = {
  mounted: installTrap,
  updated(element, binding) {
    removeTrap(element)
    installTrap(element, binding)
  },
  beforeUnmount: removeTrap
}
